// Load MapBox asynchronously
import loadable from '@loadable/component';
const mapboxgl = loadable(() => import(/* webpackChunkName: "mapbox" */ 'mapbox-gl'));

export { default as DynamicMap } from './DynamicMapboxMap';
export { default as StaticMap } from './StaticMapboxMap';

export const isMapsLibLoaded = () => {
  return typeof window !== 'undefined' && window.mapboxgl;
};

export const LoadMapsLib = (onMapsLibLoaded) => {
  if (typeof window !== 'undefined' && !window.mapboxgl) {
    mapboxgl.load().then( (mapboxgl) => {
      window.mapboxgl = mapboxgl.default;
      window.mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
      // Load css
      loadable(() => import(/* webpackChunkName: "mapbox" */ 'mapbox-gl/dist/mapbox-gl.css')).load().then(() => {
        /* Notify parent component that Mapbox map is loaded */
        onMapsLibLoaded();
      })
    })   
  }
};